import ProductPrice from "../../interfaces/ProductPrice/ProductPrice";
import ProductProperties from "../../interfaces/ProductProperties/ProductProperties";

export enum CartPageItemType {
    PRODUCT = "product",
    SERVICE = "service",
    TEST = "test"
}
export default interface CartPageItemProps {
    productProperties: ProductProperties;
    updateHandler?: () => void;
    updatePrices?: (productPrice: ProductPrice) => void;
    type?: CartPageItemType;
    cartPage?: boolean;
    license?: string;
    variant?: string;
    isDirectPurchase?: boolean;
}
